document.addEventListener("DOMContentLoaded", function () {
    const parentSelect = document.querySelector('.invite select'); 
    const childInvite = document.querySelector('.invite.select-child'); 
    const childSelect = childInvite.querySelector('select'); 

    childInvite.style.display = "none";

    function updateChildVisibility() {
        if (parentSelect.value.includes("認定講師")) { 
            childInvite.style.display = "block";
        } else {
            childInvite.style.display = "none";
            childSelect.value = ""; 
        }
    }

    const observer = new MutationObserver(updateChildVisibility);
    observer.observe(parentSelect, { attributes: true, childList: true, subtree: true });
  
    updateChildVisibility();
    parentSelect.addEventListener("change", updateChildVisibility);
});



// ヘッダーとアナウンスメントバーのスティッキー処理
if (document.querySelector('.sticky-header_all') !== null && document.querySelector('.announcement-bar') !== null) {
    const sticky_header_all = document.querySelector('.sticky-header_all');
    const sticky_padding = document.querySelector('.sticky_padding');
    const announcement_bar = document.querySelector('.announcement-bar');

    let sticky_header_allTop = sticky_header_all.getBoundingClientRect();
    let sticky_header_allTop_position = sticky_header_allTop.top + window.pageYOffset;
    let sticky_header_all_height = sticky_header_all.clientHeight;
    let announcement_bar_height = announcement_bar.clientHeight;

    let sticky_header_Animation = function () {
        let header_scroll_position = window.pageYOffset;

        if (header_scroll_position > sticky_header_allTop_position) {
            sticky_header_all.classList.add('sticky_on');
            sticky_padding.style.paddingTop = (sticky_header_all_height + announcement_bar_height) + "px";
            sticky_padding.classList.add('sticky_on');
            announcement_bar.classList.add('sticky_on');
        } else {
            sticky_header_all.classList.remove('sticky_on');
            sticky_padding.style.paddingTop = "0";
            sticky_padding.classList.remove('sticky_on');
            announcement_bar.classList.remove('sticky_on');
        }
    }

    window.addEventListener('scroll', sticky_header_Animation);
}


// フッターTOPに戻る
if(document.getElementById("side_to_top_btn_sec") != null){
	const pageTop =  document.getElementById('side_to_top_btn_sec');
	const pageTopBtn1 =  document.getElementById('side_to_top_btn');
	let Animation = function() {
	//アイコン位置取得

	//要素の位置座標を取得
	let rect = pageTop.getBoundingClientRect();
	//topからの距離
	let scrollTop = rect.top + window.pageYOffset;

	if(scrollTop > 600){
		pageTop.classList.add('show');
		}  else {
		pageTop.classList.remove('show');
		}
	}
	window.addEventListener('scroll', Animation);
	pageTopBtn1.addEventListener("click", scroll_top);
}


// フッターTOPに戻る
if(document.getElementById("footer_to_top_btn") != null){
	const pagetopBtn = document.querySelector('#footer_to_top_btn');
	pagetopBtn.addEventListener("click", scroll_top);
};

function scroll_top() {
	window.scrollTo(0, 0);
}
  

document.addEventListener('click', function (event) {
	if (event.target.matches('.faqWrap dt')) {
		event.target.classList.toggle('open');
	}
});


// 別ホストのリンクを_blankで開く
window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
	if (links[i].hostname !== window.location.hostname) {
	  links[i].target = '_blank';
	  links[i].rel = 'noreferrer noopener';
	}
  }
});

// multiGridマウススクロール

jQuery.prototype.mousedragscrollable = function () {
	let target;
	$(this).each(function (i, e) {
		$(e).mousedown(function (event) {
			event.preventDefault();
			target = $(e);
			$(e).data({
				down: true,
				move: false,
				x: event.clientX,
				y: event.clientY,
				scrollleft: $(e).scrollLeft(),
				scrolltop: $(e).scrollTop(),
			});
			return false;
		});
		$(e).click(function (event) {
			if ($(e).data("move")) {
				return false;
			}
		});
	});
	$(document)
		.mousemove(function (event) {
			if ($(target).data("down")) {
				event.preventDefault();
				let move_x = $(target).data("x") - event.clientX;
				let move_y = $(target).data("y") - event.clientY;
				if (move_x !== 0 || move_y !== 0) {
					$(target).data("move", true);
				} else {
					return;
				}
				$(target).scrollLeft($(target).data("scrollleft") + move_x);
				$(target).scrollTop($(target).data("scrolltop") + move_y);
				return false;
			}
		})
		.mouseup(function (event) {
			$(target).data("down", false);
			return false;
		});
  };
  $(".multiGrid").mousedragscrollable();


	//商品詳細ページのタブ切り替え
  $(function(){ 
		//$('.descriptionTab')が存在する場合に下記を実行
		if($('.descriptionTab').length){
			//$('.descriptionTab .tabContent--A')が存在する場合、1番目のtab_containerの中身に移動させる
			if($('.descriptionTab .tabContent--A').length){
				$('.descriptionTab .tabContent--A').appendTo($('.descriptionTab .tab__container.--A'));
			}
			//$('.descriptionTab .tabContent--B')が存在する場合、2番目のtab_containerの中身に移動させる
			if($('.descriptionTab .tabContent--B').length){
				$('.descriptionTab .tabContent--B').appendTo($('.descriptionTab .tab__container.--B'));
			}
		}
		
    $('.descriptionTab .tab__head span').click(function () { // クリックイベントを設定する
      $(this).addClass('is-active'); // クリックされたタブをアクティブにする
      $(this).siblings().removeClass('is-active'); // 兄弟要素のアクティブを解除する
      $(this).closest('.tab__head').next('.tab__containerWrap').children('.tab__container').eq($(this).index()).addClass('is-active'); // クリックされたタブに対応するコンテンツを表示する
      $(this).closest('.tab__head').next('.tab__containerWrap').children('.tab__container').not(':eq(' + $(this).index() + ')').removeClass('is-active'); // クリックされたタブ以外のコンテンツを非表示にする
    });
  });


//サイドメニュー
//アコーディオンボタン
$(function(){
	$('.accordionButton').click(function(){
		if ($(this).attr('aria-expanded') == 'false') {
			$(this).attr('aria-expanded', true);
			$(this).next().slideDown();
		} else {
				$(this).attr('aria-expanded', false);
				$(this).next().slideUp();
		}
	});
});

////header-typeE
// ナビゲーション 子要素展開
$(function() {
	var ua = navigator.userAgent;
	// タブレット・スマートフォン時
	if ((ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0||ua.indexOf('iPad') > 0) {
		$('.hasChildren > a').on('mouseenter touchstart', function(){
			$(this).toggleClass('open');
			$(this).next('ul,.megaMenu').toggleClass('open');
			return false;
		}).on('mouseleave touchend', function(){
					return false;
		});
		$('.hasChildren .hasChildren--close > a').on('mouseenter touchstart', function(){
			$(this).parents('ul').removeClass('open').prev('a').removeClass('open');
			return false;
		});

	}else{
	// PC時
		$('.hasChildren').hover(function() {
			$(this).children('a').addClass('open');
			$(this).children('ul,.megaMenu').addClass('open');
		}, function() {
			$(this).children('a').removeClass('open');
			$(this).children('ul,.megaMenu').removeClass('open');
		});
	}
});

// 検索ランキングキーワード
$(function() {
  // テキストボックスにフォーカス時、フォームの背景色を変化
  $('.search-header__form input[type="product"]')
    .focusin(function(e) {
      $(this).parents().next('.keywordRanking__toggle').addClass('open');
    })
    .focusout(function(e) {
      setTimeout(function(){
        $('.keywordRanking__toggle.open').removeClass('open');
      },200);
    });
});


//multiGridにスライダーボタンを追加
// スライダーと矢印ボタンのコンテナを全て取得
document.addEventListener('DOMContentLoaded', () => {
const multiGridContainers = document.querySelectorAll('.slider-component-multigrid');

// 各コンテナに対して処理を適用
multiGridContainers.forEach(container => {
	const multiGrid = container.querySelector('.multiGrid');
	const multiGrid__prevArrow = container.querySelector('.multiGrid__prevArrow');
	const multiGrid__nextArrow = container.querySelector('.multiGrid__nextArrow');

	//itemList__unitの横幅を取得
	let itemList__unitWidth = container.querySelector('li:first-child').offsetWidth;
	itemList__unitWidth = itemList__unitWidth + 30;

	if (multiGrid && multiGrid__prevArrow) {
		// multiGrid__prevArrowをクリックしたとき、現在地から前に移動
		multiGrid__prevArrow.addEventListener('click', function () {
			animateScroll(multiGrid, -itemList__unitWidth);
		});
	}

	if (multiGrid && multiGrid__nextArrow) {
		// multiGrid__nextArrowをクリックしたとき、現在地から後に移動
		multiGrid__nextArrow.addEventListener('click', function () {
			animateScroll(multiGrid, itemList__unitWidth);
		});
	}
});

});

function animateScroll(element, amount, duration = 200) {
	const start = element.scrollLeft;
	const end = start + amount;
	const startTime = performance.now();

	function scroll(time) {
		const elapsed = time - startTime;
		const progress = Math.min(elapsed / duration, 1);
		element.scrollLeft = start + progress * amount;

		if (progress < 1) {
			requestAnimationFrame(scroll);
		}
	}

	requestAnimationFrame(scroll);
}

$(function(){
  $(".js-more").on("click", function() {
    $(this).addClass("is-open");
    $(this).prev(".js-text").addClass("is-open");
  });
}); 